import URL from 'url-parse';
import axios from 'axios';
import Axios from 'axios/lib/core/Axios';
import cookie from 'cookie';
import { isServer, delUrlParams, serializeQs } from '@kso/util';
import isPlainObject from 'lodash/isPlainObject';
import InterceptorManager from 'axios/lib/core/InterceptorManager';
import { DRIVE } from '@kso/constants';

function relativeProtocol(uri) {
  if (uri && /^(\/\/)(.+)$/.test(uri)) {
    var protocol = isServer() && 'https' || window.location.protocol;
    uri = "".concat(protocol).concat(uri);
  }
  return uri;
}
// url脱敏函数
/**
 * @params url {string} 需要脱敏的路径url
 * @params mask {string} 替代匹配项的字符
 */
function urlMasking(url, mask) {
  /*
   * (.+?[\/|=])  ( \d{5,} 或者 (?![a-z]{10})[a-z0-9]{10} 或者 (?![a-z]{14})[a-zA-Z0-9]{14} 或者 [cs](?![a-z]+(?:\/|$))[a-zA-Z0-9]{6,} 或者 [a-zA-Z0-9]{20,} ) ([\/\?\&]|$)
   * 以./ / =开始(可选)  5位以上 数字; 10位 数字+小写;  14位 数字+小写+大写;  7位以上 c或s开头的数字+小写+大写;  20位以上  以/ ? &结束(可选)
   */
  var urlRE = /(.+?[/=])(\d{5,}|(?![a-z]{10})[a-z0-9]{10}|(?![a-z]{14})[a-zA-Z0-9]{14}|[cs](?![a-z]+(?:\/|$))[a-zA-Z0-9]{6,}|[a-zA-Z0-9,%]{20,})([/?&]|$)/g;
  var urlMask = url || '';
  urlMask = urlMask.replace(urlRE, function (str, g1, g2, g3) {
    return g1 + mask + g3;
  });
  return urlMask;
}

/**
 * @params ctx {object} 需要注入的实例
 * @params options {object} 注入的函数
 * @params options.request {function} 请求前的注入
 * @params options.response.success   请求返回成功的注入
 * @params options.response.fail      请求失败的注入
 */
function setInterceptors(ctx, options) {
  var globalRequestInterceptors = axios.interceptors.request.handlers;
  var globalResponseInterceptors = axios.interceptors.response.handlers;
  if (!ctx) {
    console.error('@kso/axios 注入第一个参数必填');
    return;
  }
  if (ctx.constructor !== axios.constructor && !(ctx instanceof Axios)) {
    console.error('@kso/axios 注入第一个参数必须是axios的工厂函数');
    return;
  }
  if (!isPlainObject(options)) {
    console.info('@kso/axios 传入的第二个参数必须是一个对象');
    return;
  }
  var _ref = options || {},
    request = _ref.request,
    response = _ref.response,
    name = _ref.name;
  if (typeof ctx.interceptors.request.unshiftUse !== 'function') {
    // fix: 暂时解决unshiftUse is not a function的问题，未找到原因，原InterceptorManager本身与axios并没有耦合，这里替换问题不大
    ctx.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  if (request) {
    if (ctx.interceptors.request.accordanceWithGlobal && globalRequestInterceptors.find(function (_ref2) {
      var fulfilled = _ref2.fulfilled;
      return fulfilled === request;
    })) {
      console.warn('全局的请求中存在相同的拦截, 跳过这个拦截');
    } else {
      ctx.interceptors.request.unshiftUse(request, null, name);
    }
  }
  if (response) {
    var success = response.success,
      fail = response.fail;

    /*
     * success = (typeof success === 'function' && success) || (r => r)
     * fail = (typeof fail === 'function' && fail) || (err => Promise.reject(err))
     */

    if (ctx.interceptors.response.accordanceWithGlobal) {
      var associated = globalResponseInterceptors.find(function (_ref3) {
        var fulfilled = _ref3.fulfilled,
          rejected = _ref3.rejected;
        return fulfilled === success || rejected == fail;
      });
      if (associated) {
        console.warn('全局的响应中存在相同的拦截, 跳过这个拦截');
      } else {
        ctx.interceptors.response.use(success, fail, name);
      }
    } else {
      ctx.interceptors.response.use(success, fail, name);
    }
  }
}
function parseDestHost(config) {
  var baseURL = config.baseURL,
    url = config.url;

  // 链接使用了相对协议URL
  baseURL = relativeProtocol(baseURL);
  url = relativeProtocol(url);

  // 保证baseURL有一个默认值
  if (!baseURL) {
    if (isServer()) {
      baseURL = DRIVE;
    } else {
      var _window$location = window.location,
        protocol = _window$location.protocol,
        host = _window$location.host;
      baseURL = "".concat(protocol, "/").concat(host);
    }
  }

  // 解析URL
  return new URL(url, baseURL);
}

/**
 * @description 添加默认拦截器，目前只有（dwpotin 和 csrftoken）
 * @param {Object} instance axios构造函数 或 其子类
 */
function initDefaultInterceptors(instance) {
  if (!isServer()) {
    var csrftoken = require('@kso/axios/interceptors/csrftoken');
    var dwpoint = require('@kso/axios/interceptors/dwpoint');
    var webKsoSid = require('@kso/axios/interceptors/webKsoSid');
    instance.addInjector(webKsoSid["default"]);
    instance.addInjector(csrftoken["default"]);
    instance.addInjector(dwpoint["default"]);
  }
}
function canUseDocument() {
  return typeof document !== 'undefined';
}
function getApiUrl(config) {
  var url = '';
  var reg = /https?/;
  if (reg.test(config.url)) {
    url = config.url;
  } else {
    // 先组装成完整的url
    url = config.baseURL + config.url;
  }
  url = delUrlParams(url);
  // 去掉http(s://，节省存储
  url = url.replace(/https?:\/\//, '');
  url = urlMasking(url, '{$KEY}');
  return url;
}
function getApiHref() {
  var href = '';
  try {
    href = window.location.href || '';
    href = href.replace(/https?:\/\//, '');
    href = urlMasking(href, '{$KEY}');
  } catch (_unused) {
    console.log('window字段不支持');
  }
  return href;
}
function getApiOriginAndReferer() {
  var href = '';
  var origin = '';
  var referer = '';
  try {
    href = window.location.href || '';
    origin = window.location.hostname || '';
    referer = href.split('?')[0].replace(/https?:\/\//, '');
    origin = urlMasking(origin, '{$KEY}');
    referer = urlMasking(referer, '{$KEY}');
  } catch (_unused2) {
    console.log('window字段不支持');
  }
  return {
    origin: origin,
    referer: referer
  };
}
function getCompleteApiUrl(config) {
  var url = '';
  var reg = /https?/;
  if (reg.test(config.url)) {
    url = config.url;
  } else {
    // 先组装成完整的url
    url = config.baseURL + config.url;
  }
  url = url.replace(/https?:\/\//, '');
  // 增加config.data中的参数
  if (config.data) {
    var params = JSON.parse(config.data);
    url = url + serializeQs(params);
  }
  url = urlMasking(url, '{$SID}');
  url = url.slice(0, 120);
  return url;
}

/**
 * @description api接口成功上报函数
 * @param {Object} response success默认传递的返回参数response
 * @param {Function} onEvent dw具体执行函数，默认为空，兼容插件自己使用的dw
 * @param {Array} successList 成功队列，存储dw未初始化前的数据
 * @param {String} env 当前环境 生产：prod；灰度：prod_rc；重保：prod-s; 测试：beta
 * @param {Boolean} isProd 是否是生产环境
 * @param {Number} successRate 成功数据上报百分比
 * @param {Boolean} reportAll 从localStorage中获取，调试用，是否全部上报
 */
function successInterceptor(response) {
  var onEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var successList = arguments.length > 2 ? arguments[2] : undefined;
  var env = arguments.length > 3 ? arguments[3] : undefined;
  var isProd = arguments.length > 4 ? arguments[4] : undefined;
  var successRate = arguments.length > 5 ? arguments[5] : undefined;
  var reportAll = arguments.length > 6 ? arguments[6] : undefined;
  var automatedTesting = arguments.length > 7 ? arguments[7] : undefined;
  try {
    // 灰度环境：prod_rc 重保：prod-s 全量上传
    if ((env === 'prod_rc' || env === 'prod-s' || isAllowReport(successRate) || reportAll) && automatedTesting !== 'kdocs_qa_pc_web') {
      var apimethod = response.config && response.config.method || '';
      var dwInfo = {
        type: 'success',
        url: apimethod + '-' + getApiUrl(response.config),
        completeurl: getCompleteApiUrl(response.config),
        href: response.config._href
      };
      if (!isProd) {
        dwInfo.env = env;
      }
      if (!onEvent) {
        if (!window.dw) {
          // dw初始化前，先缓存起来
          successList.push(dwInfo);
        } else {
          // dw初始化后，清空缓存
          while (successList.length > 0) {
            window.dw.onEvent('api_point', successList.shift());
          }
          window.dw.onEvent('api_point', dwInfo);
        }
      } else {
        onEvent('api_point', dwInfo);
      }
    }
  } catch (error) {}
}

/**
 * @description api接口失败上报函数
 * @param {Object} error fail默认传递的返回参数error
 * @param {Function} onEvent dw具体执行函数，默认为空，兼容插件自己使用的dw
 * @param {Array} errorList 失败队列，存储dw未初始化前的数据
 * @param {String} env 当前环境 生产：prod；灰度：prod_rc；重保：prod-s; 测试：beta
 * @param {Boolean} isProd 是否是生产环境
 * @param {Number} errorRate 失败数据上报百分比
 * @param {Boolean} reportAll 从localStorage中获取，调试用，是否全部上报
 */
function failInterceptor(error) {
  var onEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var errorList = arguments.length > 2 ? arguments[2] : undefined;
  var env = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'noENV';
  var isProd = arguments.length > 4 ? arguments[4] : undefined;
  var errorRate = arguments.length > 5 ? arguments[5] : undefined;
  var reportAll = arguments.length > 6 ? arguments[6] : undefined;
  var automatedTesting = arguments.length > 7 ? arguments[7] : undefined;
  var response = error.xResponse !== undefined && error.xResponse || error.response || {};
  try {
    // 灰度环境：prod_rc 重保：prod-s 全量上传
    if ((env === 'prod_rc' || env === 'prod-s' || isAllowReport(errorRate) || reportAll) && automatedTesting !== 'kdocs_qa_pc_web') {
      var msg = response.data && (response.data.msg || response.data.result) || '';
      var status = response.status;
      // 接口无响应会出现 error.response为空 error.request不为空
      if (!error.response && error.request) {
        msg = 'NO RESPONSE BODY';
        status = 'NO RESPONE CODE';
      }
      var apimethod = error.config && error.config.method || '';
      var dwInfo = {
        type: 'error',
        url: apimethod + '-' + getApiUrl(error.config),
        completeurl: getCompleteApiUrl(error.config),
        href: error.config._href,
        error_type: msg.slice(0, 50) || 'UNEXPECTED ERROR',
        error_code: status || 'UNEXPECTED ERROR'
      };
      if (response && !msg && Math.random() * 100 <= 1) {
        dwInfo.error_type = JSON.stringify(response).slice(0, 200);
      }
      if (!isProd) {
        dwInfo.env = env;
      }
      if (!onEvent) {
        if (!window.dw) {
          // dw初始化前，先缓存起来
          errorList.push(dwInfo);
        } else {
          // dw初始化后，清空缓存
          while (errorList.length > 0) {
            window.dw.onEvent('api_point', errorList.shift());
          }
          window.dw.onEvent('api_point', dwInfo);
        }
      } else {
        onEvent('api_point', dwInfo);
      }
    }
  } catch (error) {}
}

/**
 * @description 是否允许上报（是否符合在某个比例内才上报）
 * @param {Number} percentage 例如：0.1
 * @returns {Boolean}
 */
var isAllowReport = function isAllowReport(percentage) {
  return Math.random() * 100 <= percentage;
};

// 获取url参数对象，可服务端运行
function getQuery(url) {
  var query = {};
  if (url.indexOf('?') !== -1) {
    var str = url.substr(1);
    var pairs = str.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[pair[0]] = pair[1];
    }
  }
  return query; // 返回对象
}
function getCookie(name) {
  var rawcookie = {};
  if (canUseDocument()) {
    if (document && document.cookie) {
      rawcookie = cookie.parse(document.cookie);
      return rawcookie[name] || null;
    }
  }
  return null;
}
var kdocsAjax = function kdocsAjax(config) {
  return new Promise(function (resolve, reject) {
    try {
      var baseURL = config.baseURL,
        url = config.url,
        timeout = config.timeout,
        method = config.method,
        headers = config.headers,
        data = config.data,
        params = config.params,
        cancelToken = config.cancelToken;
      if (baseURL && /\/$/.test(baseURL)) {
        baseURL = baseURL.replace(/\/$/, '');
      }
      if (/^\//.test(url) && !/^\/\//.test(url)) {
        url = url.replace(/^\//, '');
      }
      var tempUrl = /^(https|http|kdochttp)/.test(url) || /^\/\//.test(url) ? url : "".concat(baseURL, "/").concat(url);
      tempUrl = tempUrl.replace(/^(https|http):\/\/kdocs.cn/, 'https://www.kdocs.cn'); // kdocs.cn必须手动替换为www.kdocs.cn, 因为部分接口自动301为www.kdocs.cn的时候 origin不见了 导致接口请求失败
      var apiUrl = new URL(tempUrl);
      tempUrl = tempUrl.replace(apiUrl.protocol, '');
      var needCache = false;
      if (params) {
        if (params.kdocsLocal) {
          needCache = true;
          delete params.kdocsLocal;
        }
        if (Object.keys(params).length) {
          var urlParams = Object.entries(params).reduce(function (pre, cur) {
            if (cur[1] === undefined) {
              return pre;
            }
            // eslint-disable-next-line no-nested-ternary
            var flag = apiUrl.search || apiUrl.query ? '&' : pre === '' ? '?' : '&';
            return "".concat(pre).concat(flag).concat(cur[0], "=").concat(cur[1]);
          }, '');
          tempUrl = "".concat(tempUrl).concat(urlParams);
        }
      }
      var clientParams = {
        url: tempUrl,
        method: method,
        body: data,
        timeout: timeout,
        headers: headers,
        cookie: {
          csrf: '123456790'
        },
        "native": {
          cacheCallback: function cacheCallback(res, data) {
            if (!window[window.clientApiKey].env().API_NOCACHE || window.kdocsNetWork === 0) {
              // 断网或首次加载列表
              if (res && [200, 403].includes(res.status)) {
                if (method.toLowerCase() === 'get' || needCache) {
                  if (window.kdocsNetWork !== 0 && (Object.prototype.toString.call(data) === '[object ReadableStream]' || !data)) {
                    return;
                  }
                  if (res.status === 200) {
                    resolve({
                      status: res.status,
                      data: data
                    });
                  } else {
                    if (!res) {
                      res = {};
                    }
                    res.data = data;
                    reject({
                      response: res
                    });
                  }
                  return;
                }
              }
            }
          },
          callback: function callback(res, data) {
            if (res.status === 200) {
              resolve({
                status: res.status,
                data: data
              });
            } else {
              if (!res) {
                res = {};
              }
              res.data = data;
              reject({
                response: res
              });
            }
          }
        }
      };
      if (method && ['post', 'put'].includes(method.toLocaleLowerCase())) {
        !clientParams.headers && (clientParams.headers = {});
        Object.assign(clientParams.headers, {
          'Content-Type': 'application/json'
        });
      }
      if (cancelToken) {
        // cancelToken  注意新老版本 旧版(0.x)axios的cancelToken是通过监听promise状态、新版(1.x)需要通过监听器来设置
        var abortRequest = '';
        clientParams["native"].cancelToken = function (abortFn) {
          abortRequest = abortFn;
        };
        if (cancelToken.subscribe) {
          cancelToken.subscribe(function (cancel) {
            if (abortRequest) {
              abortRequest();
              reject(cancel);
            }
          });
        } else if (cancelToken.promise) {
          cancelToken.promise.then(function (cancel) {
            if (abortRequest) {
              abortRequest();
              reject(cancel);
            }
          });
        }
      }
      window[window.clientApiKey].ajax(clientParams);
    } catch (error) {
      window.axiosDefaultAdapter(config).then(resolve)["catch"](reject);
    }
  });
};
function kdocsLocalAdapter(config) {
  if (!config.params) {
    config.params = {};
  }
  if (typeof window !== 'undefined' && window[window.clientApiKey] && window[window.clientApiKey].ajax) {
    return kdocsAjax(config);
  }
  return window.kdocsAxiosDefaultAdapter(config);
}

export { failInterceptor, getApiHref, getApiOriginAndReferer, getApiUrl, getCompleteApiUrl, getCookie, getQuery, initDefaultInterceptors, kdocsLocalAdapter, parseDestHost, setInterceptors, successInterceptor, urlMasking };
